import React from 'react';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import AuthLayout from '../auth/AuthLayout';
import ProfileLayout from '../layouts/ProfileLayout';
import BlogDetail from '../pages/BLOGDETAILS';
import PageNotFound from '../pages/OTHERPAGE/PageNotFound';
// import Thankyou from '../pages/OTHERPAGE/Thankyou';
import Layouts from '../layouts';
import AuthenticateUser from './AuthticateUser';
import HomePage from '../pages/DASHBOARD/Homepage';
import AllGiftCardPage from '../pages/ALLGIFTCARD/AllGiftCardPage';
import ProductDetailpage from '../pages/PRODUCTDETAILS';
import AboutPage from '../pages/ABOUTUS';
import ContactPage from '../pages/CONTACTUS';
import BlogPage from '../pages/BLOGS';
import GiftCardWorks from '../pages/GIFTCARDSWORKS';
import PrivacyPolicy from '../pages/PRIVACYPOLICY';
import TermsAndCondition from '../pages/TERMSANDCONDITION';
import Statement from '../pages/profileDashboard/statement';
import UserProfile from '../pages/profileDashboard/user';
import Order from '../pages/profileDashboard/order';
import { MobileSatement } from '../pages/profileDashboard/statement/mobileStatement';
import MobileRootLayout from '../layouts/mobileLayout/mobileRootLayout';
import { MobileOrder } from '../pages/profileDashboard/order/mobileOrder';
import MobileProfile from '../pages/profileDashboard/user/mobileProfile';
import ProductDetail from '../pages/PRODUCTDETAILS/ProductDetail';
import MobileAllGiftCardPage from '../pages/ALLGIFTCARD/mobileAllGiftCardPage';
import ThankYou from '../pages/OTHERPAGE/Thankyou';

const basename = process.env.REACT_APP_ENDPOINT || '/';

export const webRouter = createBrowserRouter([
  {
    path: '/',
    element: <Layouts />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'card-list', element: <AllGiftCardPage /> },
      { path: 'card-details/:id', element: <ProductDetailpage /> },
      { path: 'aboutus', element: <AboutPage /> },
      { path: 'contactus', element: <ContactPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'blog-details/:title', element: <BlogDetail /> },
      { path: 'how-gift-card-work', element: <GiftCardWorks /> },
      { path: 'privacypolicy', element: <PrivacyPolicy /> },
      { path: 'termsandcondition', element: <TermsAndCondition /> },
      { path: 'thank-you', element: <ThankYou /> },
      { path: '*', element: <Navigate to="/page-not-found" replace /> },
      { path: 'page-not-found', element: <PageNotFound /> },
    ],
  },
  {
    path: '/',
    element: <AuthenticateUser />,
    children: [
      { path: 'login', element: <AuthLayout /> },
      { path: 'signup', element: <AuthLayout /> },
    ],
  },
  {
    path: '/profile/*',
    element: <ProfileLayout />,
    children: [
      { index: true, element: <Navigate to="/profile/order" /> },
      {
        path: 'order',
        children: [
          { index: true, element: <Order /> },
          // { path: ':orderId', element: <ViewCards /> },
        ],
      },
      { path: 'statement', element: <Statement /> },
      { path: 'user-profile', element: <UserProfile /> },
      // { path: 'password-change', element: <ChangePassword /> },
      // { path: 'account-delete', element: <AccountDelete /> },
      { path: '*', element: <Navigate to="/profile/order" replace /> },
    ],
  },
], {
  basename,
  future: { v7_startTransition: true },
});

export const mobileRouter = createBrowserRouter([
  {
    path: '/',
    element: <MobileRootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'card-list', element: <MobileAllGiftCardPage /> },
      { path: 'card-details/:id', element: <ProductDetail /> },
      { path: 'aboutus', element: <AboutPage /> },
      { path: 'contactus', element: <ContactPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'blog-details/:title', element: <BlogDetail /> },
      { path: 'how-gift-card-work', element: <GiftCardWorks /> },
      { path: 'privacypolicy', element: <PrivacyPolicy /> },
      { path: 'termsandcondition', element: <TermsAndCondition /> },
      { path: 'thank-you', element: <ThankYou /> },
      { path: '*', element: <Navigate to="/page-not-found" replace /> },
            // { path: 'thank-you', element: <Thankyou /> },

      { path: 'page-not-found', element: <PageNotFound /> },
    ],
  },
  {
    path: '/',
    element: <AuthenticateUser />,
    children: [
      { path: 'login', element: <AuthLayout /> },
      { path: 'signup', element: <AuthLayout /> },
    ],
  },
  {
    path: '/profile/*',
    element: <MobileRootLayout />,
    children: [
      { index: true, element: <Navigate to="/profile/order" /> },
      {
        path: 'order',
        children: [
          { index: true, element: <MobileOrder /> },
        ],
      },
      { path: 'statement', element: <MobileSatement /> },
      { path: 'user-profile', element: <MobileProfile /> },
      // { path: 'password-change', element: <ChangePassword /> },
      // { path: 'account-delete', element: <AccountDelete /> },
      { path: '*', element: <Navigate to="/profile/user-profile" replace /> },
    ],
  },
], {
  basename,
  future: { v7_startTransition: true },
});
